export const MILITARY_STATE_CODES = ['AA', 'AE', 'AP'] as const

export type MilitaryStateCode = (typeof MILITARY_STATE_CODES)[number]

export const MILITARY_STATE_OPTIONS: { key: MilitaryStateCode; title: string }[] = [
  { key: 'AA', title: 'AA - Armed Forces Americas' },
  { key: 'AE', title: 'AE - Armed Forces Europe' },
  { key: 'AP', title: 'AP - Armed Forces Pacific' },
]

const MILITARY_CODE_SET = new Set<string>(MILITARY_STATE_CODES)

type AddressParts = {
  street_address1?: string | null
  city?: string | null
  state?: string | null
  postal_code?: string | null
  country?: string | null
}

/**
 * parse-address-string does not know USPS military codes (AA/AE/AP). When it leaves
 * state empty, recover the code from the city ("APO AE") or from the full address
 * immediately before the ZIP.
 */
export function recoverMilitaryState<T extends AddressParts>(addressObj: T, fullAddress: string): T {
  if (addressObj.state) return addressObj

  const city = (addressObj.city || '').trim()
  const cityMatch = city.match(/^(.*)\s+(AA|AE|AP)$/i)
  if (cityMatch) {
    return {
      ...addressObj,
      city: cityMatch[1].trim(),
      state: cityMatch[2].toUpperCase(),
    }
  }

  const zip = (addressObj.postal_code || '').trim()
  if (zip) {
    const beforeZip = new RegExp(`\\b(AA|AE|AP)\\s+${zip.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i')
    const match = fullAddress.match(beforeZip)
    if (match && MILITARY_CODE_SET.has(match[1].toUpperCase())) {
      return {
        ...addressObj,
        state: match[1].toUpperCase(),
      }
    }
  }

  return addressObj
}
